import { j as c } from "../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i, Children as m } from "react";
import { a as o } from "../../../index-CROKJrb5.js";
const n = i(({ children: r, className: e, ...t }, s) => /* @__PURE__ */ c.jsx(
  "ul",
  {
    className: o(
      "cur-m-0 cur-flex cur-flex-row cur-items-stretch cur-gap-3",
      e
    ),
    ref: s,
    ...t,
    children: r
  }
)), f = i(({ children: r, ...e }, t) => /* @__PURE__ */ c.jsx(n, { ref: t, ...e, children: m.map(r, (s, a) => /* @__PURE__ */ c.jsx("li", { className: "cur-flex cur-items-center", children: s }, a)) }));
export {
  f as NavigationItemList
};
//# sourceMappingURL=index.js.map
